import script from "./my_profile_mentor.vue?vue&type=script&setup=true&lang=ts"
export * from "./my_profile_mentor.vue?vue&type=script&setup=true&lang=ts"

import "./my_profile_mentor.vue?vue&type=style&index=0&id=2f1fb118&lang=scss&scoped=true"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1fb118"]])

export default __exports__